jQuery(document).ready(function($) { 


	 ///// MENU MOBILE /////
 //////////////////////////

	 var menu_mobile = $('#primary-menu').clone();
	 var accueil_href = $('.site-title a').attr('href');
	 var menu_rdv_en_ligne = $('#primary-menu li:last-child a').clone().addClass('btn_mobile_rdv btn_bordure');
	 $("#masthead").prepend(menu_rdv_en_ligne);
	// menu_mobile.prepend('<li><a href="'+accueil_href+'">Accueil</a></li>');

	  menu_mobile.slicknav({
	  	prependTo:"#masthead",
	    duration:300,
	    beforeOpen:move_body,
	    beforeClose:move_body,
	    allowParentLinks:true,
	    nestedParentLinks:true, // tester si c'est ok sinon false pour séparer le lien parent du s-menu
	  });

	  function move_body(){

	    if($('.slicknav_btn').hasClass('slicknav_open')){
	      $('body').addClass('move_to_right');
	    }else{
	      $('body').removeClass('move_to_right');
	    }
	  }

	  //// FIN MENU MOBILE //////


  // FORM CONTACT LABEL ///
   $( "body").on('click focus',".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea",function() {
      $(this).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


	/// LIGHTBOX ////
	$('.gallery').featherlightGallery({
			gallery: {
				fadeIn: 300,
				fadeOut: 300,
				nextIcon: '&#9654;', 
				previousIcon: '&#9664;',
			},
			openSpeed:    300,
			closeSpeed:   300
	});

	/// LIGHTBOX ////
	$('.gallery_1').featherlightGallery({
			gallery: {
				fadeIn: 300,
				fadeOut: 300,
				nextIcon: '&#9654;', 
				previousIcon: '&#9664;',
			},
			openSpeed:    300,
			closeSpeed:   300
	});

	$('.gallery_2').featherlightGallery({
			gallery: {
				fadeIn: 300,
				fadeOut: 300,
				nextIcon: '&#9654;', 
				previousIcon: '&#9664;',
			},
			openSpeed:    300,
			closeSpeed:   300
	});

	$('.gallery_3').featherlightGallery({
			gallery: {
				fadeIn: 300,
				fadeOut: 300,
				nextIcon: '&#9654;', 
				previousIcon: '&#9664;',
			},
			openSpeed:    300,
			closeSpeed:   300
	});
	$('.gallery_4').featherlightGallery({
			gallery: {
				fadeIn: 300,
				fadeOut: 300,
				nextIcon: '&#9654;', 
				previousIcon: '&#9664;',
			},
			openSpeed:    300,
			closeSpeed:   300
	});
	
	
	$.featherlightGallery.prototype.afterContent = function() {
	  debugger
	  var caption = this.$currentTarget.attr('title');
	   this.$instance.find('.caption').remove();
	  if(caption){
	 
	  $('<div class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
		}
	};


	
	//// FIN LIGHTBOX ///


	// ACCORDEON
	//$('.accordion-section-content').not( "#content_s_1" ).hide();
	$('.accordion-section-content').hide();
    //$('.accordeon-page > section:first-child a').addClass('active');

   //$('.accordion-section-content').hide();
   	// ACCORDEON SECTION 
   	function close_accordion_section() {
        $('.accordeon-page .accordion-section-title').removeClass('active');
        $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
 
        if($(this).hasClass('active')) {
          
           // close_accordion_section();
           // $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open'); 
            $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).addClass('active');
            // Open up the hidden content panel
            $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });


	// TAB TECHNIQUE // 
	 // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".tab_content").hide();
    $(".tab_content:first").show();

  /* if in tab mode */
    $("ul.tabs li").click(function() {
		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();		
		
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".tab_drawer_heading").removeClass("d_active");
	  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    });
	/* if in drawer mode */
	$(".tab_drawer_heading").click(function() {
      
      if($(this).next().css('display') == 'none'){
		      $(".tab_content").hide();
		      var d_activeTab = $(this).attr("rel"); 
		      $("#"+d_activeTab).fadeIn();
			  
			  $(".tab_drawer_heading").removeClass("d_active");
		      $(this).addClass("d_active");
			  
			  $("ul.tabs li").removeClass("active");
			  $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
		}else{
			$(this).next().slideUp(400);
			$(".tab_drawer_heading, ul.tabs li").removeClass("d_active");
		}
    });

	
	/* Extra class "tab_last" 
	   to add border to right side
	   of last tab */
	$('ul.tabs li').last().addClass("tab_last");

	// GET HASH ? 
	 // SI #tab1, #tab2, #tab3.. alors on clique sur le li pour activer le bon tab_content //
	 if(window.location.hash) {
	 	var $hash_location = window.location.hash;
	  if($hash_location == '#tab1' || $hash_location == '#tab2' || $hash_location == '#tab3' || $hash_location == '#tab4')
	  {
	  	$hash_location = $hash_location.substring(1);
	  	$( "ul.tabs li[rel='"+$hash_location+"']").trigger( "click" );
	    $('html, body').animate({scrollTop: $("ul.tabs").offset().top-150}, 500);
		  
	  }
	} 
	// FIN TAB TECHNIQUE //



	// OWL CAROUSEL HOME
	 var owl_home_page = $("#home_sticky");

 	if ( $( owl_home_page).length ) {
	  owl_home_page.owlCarousel({
	  	 loop:true,
	  	 autoplay:true,
	  	 autoplayTimeout:5500,
	  	 autoplaySpeed:1500,
         navSpeed:1300,
         smartSpeed:1300,
         fluidSpeed:1300,
    	 margin:0,
   		 nav:false,
   		 items:1,
 		   // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
	  });
   }
	///// ////// //// FIN DIAPORAMA TOP HOME ///// /////// ///// 

	contain_slide = $('.slide_top');
	header = $("#masthead");
	page = $('#page');
	body = $('body');
	h_contain_slide = contain_slide.height();
	 $(window).scroll(function () {
		action_on_scroll();
    });

	 function action_on_scroll(){

			var l_window = parseInt($(window).width());
			
			if (l_window > 950){
	            if ($(window).scrollTop() > 50){
					header.addClass("fixed_scrol");
					body.addClass('menu_fixed_scrol')
	            }else{
	            	header.removeClass("fixed_scrol");
	            	body.removeClass('menu_fixed_scrol')
	            }
	       
	              // besoin de placer le sous-menu //
	            if (contain_slide.length){
		 			

		 			if ($(window).scrollTop() > h_contain_slide - 150){
						header.removeClass("menu_on_slide");
						page.addClass('to_black');
	            	}else{
	            		header.addClass("menu_on_slide");
	            		page.removeClass('to_black');
	            	}
					
		           // console.log("H height : "+parseInt($(window).scrollTop() + admin_bar + h_header));
		           // console.log("Top menu : "+parseInt($(window).scrollTop() + h_header + admin_bar));		
				}

	        }   
	 } // fin action on scroll

});